import React, { useState, useEffect } from 'react';
import { FaInstagram, FaLinkedin } from 'react-icons/fa';
import { SiGitlab } from 'react-icons/si';
import { menuData } from '../data/MenuData';
import './NavOverlay.css';

const NavOverlay = ({ isOpen, onClose }) => {
  // Tracks which nav item is hovered — drives the background image
  const [activeIndex, setActiveIndex] = useState(null);

  // Close on Escape
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  // Lock scroll on both html and body when open
  useEffect(() => {
    const val = isOpen ? 'hidden' : '';
    document.documentElement.style.overflow = val;
    document.body.style.overflow = val;
    return () => {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  // Reset hover state when overlay closes
  useEffect(() => {
    if (!isOpen) setActiveIndex(null);
  }, [isOpen]);

  return (
    <div className={`nav-overlay${isOpen ? ' open' : ''}`} aria-hidden={!isOpen}>
      <div className="overlay-inner">

        {/* ── Left panel — identity + social ─────────────────────────── */}
        <div className="overlay-nav-info">
          <div className="overlay-info-content">
            <p className="nav-info-text nav-info-name">Mac Villanueva</p>
            <p className="nav-info-text nav-info-role">AWS DevOps Engineer</p>

            <div className="overlay-info-social">
              <span className="overlay-follow-label">Follow me</span>
              <div className="overlay-social-icons">
                <a
                  href="//www.instagram.com"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                  className="overlay-social-icon overlay-social-icon--instagram"
                >
                  <FaInstagram />
                </a>
                <a
                  href="//www.linkedin.com/in/engrmacvillanueva/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="LinkedIn"
                  className="overlay-social-icon overlay-social-icon--linkedin"
                >
                  <FaLinkedin />
                </a>
                <a
                  href="//gitlab.com/Mackkooyy/www.engineermac.com"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="GitLab"
                  className="overlay-social-icon overlay-social-icon--gitlab"
                >
                  <SiGitlab />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* ── Right panel — nav links + background image ──────────────── */}
        <div className="overlay-nav-links">

          {/* Background image stack — one per menu item, active one fades in */}
          <div className="overlay-bg-stack" aria-hidden="true">
            {menuData.map((item, i) => (
              <img
                key={item.link}
                src={item.image}
                alt=""
                className={`overlay-bg-img${activeIndex === i ? ' overlay-bg-img--active' : ''}`}
                loading="lazy"
              />
            ))}
          </div>

          {/* Dark scrim — keeps nav text readable over the image */}
          <div className="overlay-bg-scrim" aria-hidden="true" />

          {/* Nav items */}
          <nav className="overlay-links-nav">
            {menuData.map((item, i) => (
              <a
                key={item.link}
                href={item.link}
                className={`overlay-nav-link${activeIndex === i ? ' overlay-nav-link--active' : ''}`}
                onMouseEnter={() => setActiveIndex(i)}
                onMouseLeave={() => setActiveIndex(null)}
                onClick={onClose}
              >
                <span className="overlay-link-inner">
                  <span className="overlay-nav-num">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="nav-link-text">{item.title}</span>
                </span>
              </a>
            ))}
          </nav>

        </div>

      </div>
    </div>
  );
};

export default NavOverlay;
